import { useState, useEffect, useMemo } from "react";
import { DiliTextCP } from "../Utility/DiliTextCP";
import { viewStates, emails } from "../../constants";
import {
  getPublicTrackerAdditionalParcelTracking,
  getCXTOrderByBarcode,
  getDeliveryByBOL,
} from "../../services/deliveryService";
import { format as dateFormat, parseISO } from "date-fns";
import SimpleTransitionBoth from "../Utility/SimpleTransitionBoth";
import { LoadingSpinner } from "../Utility/LoadingSpinner";
// import handleApiError from "../../helpers/handleApiError";
import { toast } from "react-toastify";
import SimpleFadeIn from "../Utility/SimpleFadeIn";
import { GleamPanel } from "../Utility/GleamPanel";
import { HelmetUtil } from "../Utility/HelmetUtil";
import { PODModal } from "../Utility/PODModal";
import {
  determineOverallStatusForSingleBarcode,
  // processAndFilterStops,
  stopCountsAsScanned,
  svgStringToBase64,
  // svgStringToImgSrc,
} from "../../helpers/utilities";
import { BsImage } from "react-icons/bs";
import { FaFileSignature } from "react-icons/fa";
import { useLocation, useHistory } from "react-router-dom";
import { isClient } from "../../services/accountService";
import { FullPageParcelImageModal } from "../Utility/FullPageParcelImageModal";

const TrackingHistoryViewStateSpacer = ({ children }) => {
  return (
    <div
      style={{
        display: "grid",
        placeContent: "center",
        textAlign: "center",
        padding: "2rem",
        minHeight: "300px",
      }}
    >
      {children}
    </div>
  );
};

const MiddleNotch = () => {
  return (
    <div
      style={{
        width: "5px",
        height: "100%",
        display: "grid",
        placeContent: "center",
      }}
      className="bg-completion-green"
    >
      <div
        className="bg-completion-green"
        style={{
          width: "15px",
          height: "25px",
        }}
      ></div>
    </div>
  );
};
const StartingNotch = () => {
  return (
    <div
      style={{
        width: "5px",
        display: "grid",
        // height: "100%",
        // placeContent: "center",
        height: "60%",
        placeContent: "end center",
      }}
      className="bg-completion-green"
    >
      <div
        className="bg-completion-green"
        style={{
          width: "15px",
          height: "25px",
        }}
      ></div>
    </div>
  );
};
const EndingNotch = () => {
  return (
    <div
      style={{
        width: "5px",
        height: "52%",
        display: "grid",
        position: "absolute",
        bottom: 0,
        placeItems: "start",
      }}
      className="bg-completion-green"
    >
      <div
        className="bg-completion-green"
        style={{
          width: "25px",
          height: "5px",
        }}
      ></div>
    </div>
  );
};

const errorTypes = {
  noBarcodeFoundError: "noBarcodeFound",
};
const searchTypes = {
  barcode: "Barcode",
  invoice: "Invoice",
  referenceNo: "Reference",
};
export const PublicTracker = () => {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchTypeParam = searchParams.get("searchtype");
  const barcodeSearchParam = searchParams.get("barcode");
  const clientSearchParam = searchParams.get("clientid");
  const invoiceOrReferenceSearchParam =
    searchTypeParam === searchTypes.invoice
      ? searchParams.get("invoice")
      : searchParams.get("reference");

  // console.log(barcodeSearchParam);
  // useEffect(()=>{
  //   // console.log("use effect", searchParams);
  //   // console.log(searchParams.get("barcode"))
  //   if(barcodeSearchParam){
  //     setBarcodeSearchFormValue(barcodeSearchParam);
  //     handleSubmitBarcodeTrackingSearch(null, barcodeSearchParam)
  //   }
  // }, [])

  const [searchType, setSearchType] = useState(searchTypes.barcode);
  const handleChangeSearchType = (e) => {
    setSearchType(e.target.value);
  };
  const [barcodeSearchFormValue, setBarcodeSearchFormValue] = useState("");
  const [lastSearchedBarcodeInvoiceOrRef, setLastSearchedBarcodeInvoiceOrRef] =
    useState("");
  const [lastSearchType, setLastSearchType] = useState("");
  const [clientIdSearchFormValue, setClientIdSearchFormValue] = useState("");
  const [invoiceSearchFormValue, setInvoiceSearchFormValue] = useState("");
  const [viewState, setViewState] = useState(viewStates.initial);
  const [trackingHistoryByBarcode, setTrackingHistoryByBarcode] = useState([]);
  const [associatedBarcodes, setAssociatedBarcodes] = useState([]);
  const [selectedBarcode, setSelectedBarcode] = useState();
  const [error, setError] = useState();
  // const [issuesWithBarcode, setIssuesWithBarcode] = useState([]);
  // const [overallStatus, setOverallStatus] = useState("");
  const [isPendingReceiptFromShipper, setIsPendingReceiptFromShipper] =
    useState(false);
  const [showPODSignatureModal, setShowSignaturePODModal] = useState(false);
  const [podSignatureModalImage, setPODSignatureModalImage] = useState("");
  const [podSignatureModalSignedBy, setPODSignatureModalSignedBy] =
    useState("");
  const [foundDeliveryImageInfo, setFoundDeliveryImageInfo] = useState();
  const [showParcelImageModal, setShowParcelImageModal] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const handleClickParcelImageModal = (image) => {
    setSelectedImage(image);
    setShowParcelImageModal(true);
  };
  const handleCloseParcelImageModal = () => {
    setShowParcelImageModal(false);
  };
  const handleSelectBarcode = (barcode) => {
    setSelectedBarcode(barcode);
  };
  const handleClickPODSignatureImage = (podImage, signedBy) => {
    setPODSignatureModalImage(svgStringToBase64(podImage));
    setPODSignatureModalSignedBy(signedBy);
    setShowSignaturePODModal(true);
  };
  const handleClosePODSignatureImage = () => {
    setShowSignaturePODModal(false);
  };

  const handleChangeBarcodeSearchFormValue = (event) => {
    setBarcodeSearchFormValue(event.target.value);
    // history.replace({
    //   pathname:"TrackBarcode",
    //   search:`?barcode=${event.target.value}`
    // })
  };
  const handleClientIDKeyDown = (event) => {
    // console.log(event);
    if (
      !/^\d+$/.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Tab" &&
      !(
        (
          event.ctrlKey &&
          (event.key === "c" || //copy
            event.key === "x" || //cut
            event.key === "v" || //paste
            event.key === "a" || //select all
            event.key === "z" || //undo
            event.key === "Z" || //redo (ctrl + shift + z)
            event.key === "y")
        ) //redo (ctrl + y)
      ) &&
      event.key !== "Enter"
    ) {
      event.preventDefault();
      return;
    }
  };
  const handleChangeClientIdSearchFormValue = (event) => {
    setClientIdSearchFormValue(event.target.value);
  };
  const handleChangeInvoiceSearchFormValue = (event) => {
    setInvoiceSearchFormValue(event.target.value);
  };
  const handleSubmitBarcodeTrackingSearch = async (
    searchType,
    barcodeToSearch,
    clientID,
    invoiceToSearch,
  ) => {
    // console.log(searchType);
    // console.log(barcodeToSearch);
    if (
      searchType === searchTypes.barcode &&
      (!barcodeToSearch || barcodeToSearch?.length < 1)
    ) {
      toast.warn("No barcode entered");
      return;
    }
    // console.log(barcodeToSearch?.length < 1);
    if (
      (searchType === searchTypes.invoice ||
        searchType === searchTypes.referenceNo) &&
      (!clientID || clientID?.length < 1)
    ) {
      toast.warn(`${searchType} search must include a client ID.`);
      return;
    }
    if (
      (searchType === searchTypes.invoice ||
        searchType === searchTypes.referenceNo) &&
      (!invoiceToSearch || invoiceToSearch?.length < 1)
    ) {
      toast.warn(`No ${searchType?.toLowerCase()} entered`);
      return;
    }
    const searchTermToTest =
      searchType === searchTypes.barcode ? barcodeToSearch : invoiceToSearch;
    if (!/^[a-zA-Z0-9-_ \\*]+$/.test(searchTermToTest?.trim())) {
      toast.warn(
        `${searchType}s with special characters or spaces are not currently supported. Please contact ${emails.supportEmail} for assistance.`,
      );
      return;
    }
    try {
      setViewState(viewStates.loading);
      setIsPendingReceiptFromShipper(false); // resetting
      setLastSearchedBarcodeInvoiceOrRef(
        searchType === searchTypes.barcode
          ? barcodeToSearch?.trim()
          : invoiceToSearch?.trim(),
      );
      setLastSearchType(searchType);
      setAssociatedBarcodes([]);
      setError(null);
      let trackingHistoryResponse;
      if (searchType === searchTypes.barcode) {
        trackingHistoryResponse = await getCXTOrderByBarcode(
          [barcodeToSearch.trim()],
          // new Date(),
          // dateAdd(new Date(), { days: -7 })
        );
      } else {
        trackingHistoryResponse = await getDeliveryByBOL(
          clientID,
          [invoiceToSearch.trim()],
          searchType === searchTypes.referenceNo ? true : false, //this should be true if we want to search by reference number and false if we want to search by invoice number
        );
      }
      if (trackingHistoryResponse.data.length === 0) {
        setViewState(viewStates.nodata);
        return;
      }
      const filteredTrackingHistory = trackingHistoryResponse?.data?.filter(
        (stop) => {
          return stopCountsAsScanned(stop);
        },
      );
      //if there were scans but all were filtered out:
      //that means there are expected scans (i.e. the order is in the system) but the barcode hasn't been scanned anywhere yet.
      // console.log(filteredTrackingHistory);
      // console.log(trackingHistoryResponse.data);
      if (
        filteredTrackingHistory.length === 0 &&
        trackingHistoryResponse.data.length > 0
      ) {
        // console.log("is true");
        setIsPendingReceiptFromShipper(true);
      }
      if (filteredTrackingHistory.length === 0) {
        setViewState(viewStates.nodata);
        return;
      }

      const trackingHistoryByBarcode = trackingHistoryResponse.data.reduce(
        (rolling, current) => {
          if (rolling[current.barcode]) {
            rolling[current.barcode].push(current);
          } else {
            rolling[current.barcode] = [current];
          }
          return rolling;
        },
        {},
      );

      for (const barcode of Object.keys(trackingHistoryByBarcode)) {
        trackingHistoryByBarcode[barcode] =
          determineOverallStatusForSingleBarcode(
            trackingHistoryByBarcode[barcode],
          );
      }

      // console.log(trackingHistoryByBarcode);

      // for (let i = 0; i < filteredTrackingHistory.length; i++) {
      //   trackingHistoryByBarcode[filteredTrackingHistory[i].barcode].push(
      //     ({
      //       status: overallStatusResult,
      //       issues,
      //       processedTrackingHistory,
      //     } = determineOverallStatusForSingleBarcode(
      //       filteredTrackingHistory[i]
      //     ))
      //   );
      // }

      // console.log(trackingHistoryByBarcode);

      //We want to use the original tracking history, as we need to show all barcodes on the order, even if there are no scans for it.
      let associatedBarcodesFoundSet = new Set();
      trackingHistoryResponse?.data?.map((trackingEvent) => {
        associatedBarcodesFoundSet.add(trackingEvent.barcode);
      });
      const associatedBarcodesFoundArray = [...associatedBarcodesFoundSet];

      setAssociatedBarcodes(associatedBarcodesFoundArray.sort());
      setSelectedBarcode(associatedBarcodesFoundArray[0]);

      // for (let i = 0; i < associatedBarcodesFoundArray.length; i++) {
      //   let {
      //     status: overallStatusResult,
      //     issues,
      //     processedTrackingHistory,
      //   } = determineOverallStatusForSingleBarcode(filteredTrackingHistory);
      // }

      if (
        [
          23583, //bb
          15053, //s
          15406,
          18933,
          18936,
          22927,
        ].includes(
          filteredTrackingHistory[filteredTrackingHistory.length - 1]?.custID,
        )
      ) {
        //fetch images for delivery
        const additionalParcelTrackingHistoryResponse =
          await getPublicTrackerAdditionalParcelTracking(
            filteredTrackingHistory[filteredTrackingHistory.length - 1]
              ?.parcelId,
            isClient(),
          );

        if (
          additionalParcelTrackingHistoryResponse?.data?.attachments.length > 0
        ) {
          setFoundDeliveryImageInfo(
            additionalParcelTrackingHistoryResponse.data.attachments,
          );
        } else {
          //if nothing was found for images reset this or we will incorrectly see the last found images
          //i.e. user searches for a barcode and sees image 1, user searches for another barcode and sees image 2, user searches for another barcode which doesn't have images, but he will see image 2 again.
          setFoundDeliveryImageInfo();
        }
      }
      // const {processedStops: processedTrackingHistory, issues} = processAndFilterStops(
      //   filteredTrackingHistory
      // );
      // const sortedByExpectedSequence = processedTrackingHistory.sort((a, b) => {
      //   return b.expectedStopScanSeq - a.expectedStopScanSeq;
      // });
      // console.log(sortedByExpectedSequence);
      // let {
      //   status: overallStatusResult,
      //   issues,
      //   processedTrackingHistory,
      // } = determineOverallStatusForSingleBarcode(filteredTrackingHistory);
      // setOverallStatus(overallStatusResult);
      setTrackingHistoryByBarcode(trackingHistoryByBarcode);
      // setIssuesWithBarcode(issues);

      setViewState(viewStates.success);
    } catch (ex) {
      // console.log(ex);
      if (ex?.response?.data?.message?.includes("No Packages/Barcodes found")) {
        setError(errorTypes.noBarcodeFoundError);
      }
      toast.error(
        "" + (ex?.response?.data?.message ? ex?.response?.data?.message : ex),
      );
      // toast.error(
      //   "There was an issue while trying to load tracking history for this barcode. Please try again."
      // );
      setViewState(viewStates.error);
    }
  };

  // console.log(isPendingReceiptFromShipper);
  // console.log(viewState);
  // console.log("outer");
  // console.log("associated barcodes found", associatedBarcodes);
  // console.log("selected barcode", selectedBarcode);

  const handleSubmit = (event) => {
    event?.preventDefault();
    if (
      searchType === searchTypes.barcode &&
      barcodeSearchFormValue != barcodeSearchParam
    ) {
      // console.log("updated url");
      history.push({
        pathname: location.pathname,
        search: `?searchtype=${searchType}&barcode=${barcodeSearchFormValue}`,
      });
    } else if (
      (searchType === searchTypes.invoice ||
        searchType === searchTypes.referenceNo) &&
      (searchType !== searchTypeParam ||
        clientIdSearchFormValue != clientSearchParam ||
        invoiceSearchFormValue != invoiceOrReferenceSearchParam)
    ) {
      history.push({
        pathname: location.pathname,
        search: `?searchtype=${searchType}&clientid=${clientIdSearchFormValue}&${
          searchType === searchTypes.invoice ? "invoice" : "reference"
        }=${invoiceSearchFormValue}`,
      });
    } else {
      // console.log("searched directly through form");
      handleSubmitBarcodeTrackingSearch(
        searchType,
        barcodeSearchParam,
        clientSearchParam,
        invoiceOrReferenceSearchParam,
      );
    }
  };
  useEffect(() => {
    // console.log("searched through url change");
    // if (searchTypeParam === null) {
    //   return;
    // }
    if (
      !Object.values(searchTypes).includes(
        searchTypeParam ?? searchTypes.barcode,
      )
    ) {
      toast.error("Search type is not valid.");
      return;
    }
    if (
      barcodeSearchParam === null &&
      (clientSearchParam === null || invoiceOrReferenceSearchParam === null)
    ) {
      return;
    }
    // const initialSearchType = invoiceSearchParam
    //   ? searchTypes.invoice
    //   : searchTypes.barcode;
    // console.log("invoiceSearchParam", invoiceSearchParam);
    setSearchType(searchTypeParam ?? searchTypes.barcode);
    setBarcodeSearchFormValue(barcodeSearchParam ?? "");
    setClientIdSearchFormValue(clientSearchParam ?? "");
    setInvoiceSearchFormValue(invoiceOrReferenceSearchParam ?? "");
    // setAssociatedBarcodes([]);
    // setBarcodeTrackingHistory([]);
    handleSubmitBarcodeTrackingSearch(
      searchTypeParam ?? searchTypes.barcode,
      barcodeSearchParam,
      clientSearchParam,
      invoiceOrReferenceSearchParam,
    );
  }, [
    searchTypeParam,
    barcodeSearchParam,
    clientSearchParam,
    invoiceOrReferenceSearchParam,
  ]);
  const barcodeTrackingHistory = useMemo(() => {
    return (
      trackingHistoryByBarcode[selectedBarcode]?.processedTrackingHistory ?? []
    );
  }, [trackingHistoryByBarcode, selectedBarcode]);
  const overallStatus = useMemo(() => {
    return trackingHistoryByBarcode[selectedBarcode]?.status;
  }, [trackingHistoryByBarcode, selectedBarcode]);
  const issuesWithBarcode = useMemo(() => {
    return trackingHistoryByBarcode[selectedBarcode]?.issues;
  }, [trackingHistoryByBarcode, selectedBarcode]);
  // console.log("search type", searchType);
  return (
    <>
      <HelmetUtil title="Track Barcode" />
      <PODModal
        show={showPODSignatureModal}
        handleCloseModal={handleClosePODSignatureImage}
        podSignature={podSignatureModalImage}
        podName={podSignatureModalSignedBy}
        orderLevel={false}
        // barcode={lastSearchedBarcodeInvoiceOrRef}
        barcode={selectedBarcode}
        showPodComment={false}
      />
      <FullPageParcelImageModal
        show={showParcelImageModal}
        handleCloseModal={handleCloseParcelImageModal}
        // imageURLToFetch={imageURLToFetch}
        selectedImage={selectedImage}
        barcode={barcodeSearchParam}
        caption={() => {
          return <div>Parcel Image</div>;
        }}
        textUnderImage
        isPublicTracker
      />
      <div
        className="remove-global-padding"
        style={{ backgroundColor: "rgb(245,245,245)", minHeight: "100vh" }}
      >
        {/* for some reason (probably due to remove-global-padding + row/col padding/margins) page gets a horizontal scrollbar with a little space on the side. So we set overflowX to hidden but for some reason it hides bottom shadow, so put some padding bottom on it for extra space.  */}
        <div style={{ overflowX: "hidden", paddingBottom: "2rem" }}>
          <div className="row">
            <div className="col-lg-6 px-5 pr-lg-3 pt-4 pb-2 py-lg-4">
              <div
                className="paper-card-heavy px-5 pt-5 pb-4 bg-dil-blue text-light"
                style={{
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: "5px",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    zIndex: 2,
                    textShadow: "0px 1px 2px black",
                  }}
                >
                  <div className="mb-5">
                    <h3>Diligent Delivery Systems®</h3>
                    <h2>Shipment Tracker</h2>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="form-row">
                      {/* <DiliTextCP
                      className="col-md-6 mb-2"
                      type="date"
                      label="Date Range"
                    />
                    <DiliTextCP
                      className="col-md-6 mb-3"
                      type="date"
                      style={{ paddingTop: "2rem" }}
                    /> */}
                      <DiliTextCP
                        type="select"
                        label="Search By"
                        labelStyle={{ whiteSpace: "nowrap" }}
                        className="col-12 mb-2 col-md-2 mb-md-0 col-lg-12 mb-lg-2 col-xl-2 mb-xl-0"
                        onChange={handleChangeSearchType}
                        value={searchType}
                      >
                        <option value={searchTypes.barcode}>Barcode</option>
                        <option value={searchTypes.invoice}>Invoice</option>
                        <option value={searchTypes.referenceNo}>
                          Reference
                        </option>
                      </DiliTextCP>
                      {searchType === searchTypes.barcode && (
                        <DiliTextCP
                          className="col-12 col-md-10 col-lg-12 col-xl-10"
                          label="Barcode"
                          labelStyle={{ opacity: 0 }}
                          placeholder="Enter Barcode"
                          value={barcodeSearchFormValue}
                          onChange={handleChangeBarcodeSearchFormValue}
                        />
                      )}
                      {(searchType === searchTypes.invoice ||
                        searchType === searchTypes.referenceNo) && (
                        <>
                          <DiliTextCP
                            className="col-12 mb-2 col-md-10 col-lg-12 col-xl-10"
                            label="Client ID"
                            labelStyle={{ opacity: 0 }}
                            labelClass="d-none d-md-block d-lg-none d-xl-block"
                            placeholder="Enter Client ID"
                            maxLength={20}
                            value={clientIdSearchFormValue}
                            onChange={handleChangeClientIdSearchFormValue}
                            onKeyDown={handleClientIDKeyDown}
                          />
                          <DiliTextCP
                            className="col-12 col-md-12 col-lg-12 col-xl-12"
                            // label="Invoice"
                            // labelStyle={{ opacity: 0 }}
                            placeholder={`Enter ${
                              searchType === searchTypes.invoice
                                ? "Invoice"
                                : "Reference Number"
                            }`}
                            value={invoiceSearchFormValue}
                            onChange={handleChangeInvoiceSearchFormValue}
                          />
                        </>
                      )}
                    </div>
                    <div className="pt-3 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-primary button-lg-full-width"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
                <div
                  className="bg-dil-red"
                  style={{
                    width: "10px",
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                  }}
                ></div>

                {/* <div
                  className="bg-dil-red"
                  style={{
                    width: "70px",
                    height: "20px",
                    position: "absolute",
                    right: "50px",
                    top: "80px",
                    transform: "skew(-45deg)",
                  }}
                ></div>
                <div
                  className="bg-dil-red"
                  style={{
                    width: "90px",
                    height: "20px",
                    position: "absolute",
                    right: "90px",
                    top: "87px",
                    transform: "skew(-45deg)",
                  }}
                ></div>
                <div
                  className="bg-dil-red"
                  style={{
                    width: "70px",
                    height: "10px",
                    position: "absolute",
                    right: "50px",
                    top: "60px",
                    transform: "skew(-45deg)",
                  }}
                ></div>
                <div
                  className="bg-dil-red"
                  style={{
                    width: "90px",
                    height: "20px",
                    position: "absolute",
                    right: "90px",
                    top: "37px",
                    transform: "skew(-45deg)",
                  }}
                ></div> */}
              </div>
            </div>
            <div className="col-lg-6 px-5 pl-lg-3 py-3 py-lg-4">
              <div
                className="paper-card-heavy p-4 p-md-5"
                style={{
                  backgroundColor: "white",
                  height: "100%",
                  borderRadius: "5px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {viewState !== viewStates.loading && (
                  <>
                    <div>
                      <h3 className="text-center text-note mb-0">
                        {selectedBarcode} Status
                      </h3>
                    </div>
                    <div
                      className=" font-600"
                      style={{
                        borderRadius: ".3rem",
                        padding: "0rem 1rem 0rem 1rem",
                        flex: 1,
                        display: "grid",
                        placeContent: "center",
                        textAlign: "center",
                        margin: ".9rem 0rem 1.2rem 0rem",
                        fontSize: "1.125rem",
                        backgroundColor:
                          viewState === viewStates.success ||
                          isPendingReceiptFromShipper
                            ? "#C2DFEF"
                            : "",
                      }}
                    >
                      {viewState === viewStates.success ||
                      isPendingReceiptFromShipper
                        ? isPendingReceiptFromShipper
                          ? "Pending Receipt From Shipper"
                          : overallStatus
                        : "-"}
                      {/* {viewState === viewStates.loading && (
                    <GleamPanel
                      height="2rem"
                      darker
                      style={{ width: "12rem", margin: "auto" }}
                    />
                  )} */}

                      <div className="text-center text-17 text-danger">
                        {viewState === viewStates.success
                          ? issuesWithBarcode.length > 0
                            ? issuesWithBarcode.map((issue, index) => {
                                return <div key={index}>{issue}</div>;
                              })
                            : ""
                          : ""}
                      </div>
                    </div>
                    <div>
                      <div
                        className="py-3 px-3"
                        style={{
                          backgroundColor: "rgb(240,240,240)",
                        }}
                      >
                        <div className="row">
                          <div className="col-md-5 font-600 text-center text-md-left">
                            Last Activity{" "}
                          </div>
                          <div className="col-md-7 text-center text-md-right">
                            {viewState === viewStates.success
                              ? barcodeTrackingHistory?.[0]?.name
                              : "-"}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-5 font-600 text-center text-md-left">
                            Last location
                          </div>
                          <div className="col-md-7 text-center text-md-right">
                            {viewState === viewStates.success
                              ? `${barcodeTrackingHistory?.[0]?.city ?? "-"},
                          ${barcodeTrackingHistory?.[0]?.state ?? "-"} ${
                            barcodeTrackingHistory?.[0]?.zip ?? "-"
                          }`
                              : "-"}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4 font-600 text-center text-md-left">
                            Last Scan{" "}
                          </div>
                          <div className="col-md-8 text-center text-md-right">
                            {viewState === viewStates.success
                              ? barcodeTrackingHistory?.[0]?.scannedWhen
                                ? dateFormat(
                                    parseISO(
                                      barcodeTrackingHistory?.[0].scannedWhen,
                                    ),
                                    "MM/dd/yyyy h:mm a",
                                  )
                                : barcodeTrackingHistory?.[0]?.completedTime
                                  ? dateFormat(
                                      parseISO(
                                        barcodeTrackingHistory?.[0]
                                          .completedTime,
                                      ),
                                      "MM/dd/yyyy h:mm a",
                                    )
                                  : "Expected"
                              : "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {viewState === viewStates.loading && (
                  <GleamPanel
                    darker
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                    }}
                  />
                )}
              </div>
            </div>

            <div className="col-12 px-5 py-2">
              <div
                className="paper-card-heavy"
                style={{ borderRadius: "5px 5px 0px 0px" }}
              >
                <div
                  className="p-5 bg-light"
                  style={{ borderRadius: "5px 5px 0px 0px" }}
                >
                  <h3 style={{ marginBottom: "6px" }}>Tracking History</h3>
                  <div>
                    {viewState !== viewStates.initial &&
                    viewState !== viewStates.loading ? (
                      <SimpleFadeIn>
                        <span style={{ fontWeight: 600 }}>
                          Packages found for {lastSearchType}{" "}
                          {lastSearchedBarcodeInvoiceOrRef}:
                        </span>
                        <br />
                        {associatedBarcodes?.length === 0 &&
                          "No packages found"}
                        <div style={{ marginLeft: "-5px" }}>
                          {associatedBarcodes.map((barcode, index) => {
                            return (
                              <div
                                key={barcode + "-" + index}
                                className={`public-tracker-barcode-chip${
                                  barcode === selectedBarcode
                                    ? " chip-selected"
                                    : ""
                                }`}
                                onClick={() => {
                                  handleSelectBarcode(barcode);
                                }}
                              >
                                {barcode} <br />
                                {trackingHistoryByBarcode[barcode]?.status}
                              </div>
                            );
                          })}
                        </div>
                      </SimpleFadeIn>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div
                  style={{
                    backgroundColor: "rgb(230,230,230)",
                    overflow: "hidden",
                  }}
                >
                  {viewState === viewStates.initial && (
                    <TrackingHistoryViewStateSpacer>
                      Enter a barcode to view tracking history.
                    </TrackingHistoryViewStateSpacer>
                  )}
                  {viewState === viewStates.loading && (
                    <TrackingHistoryViewStateSpacer>
                      <LoadingSpinner spinnerClassAppend="text-note" />
                    </TrackingHistoryViewStateSpacer>
                  )}
                  {viewState === viewStates.error && (
                    <TrackingHistoryViewStateSpacer>
                      {error === errorTypes.noBarcodeFoundError ? (
                        <>
                          There were no packages/barcodes found for this{" "}
                          {lastSearchType?.toLowerCase()}.
                        </>
                      ) : (
                        <>
                          There was an issue loading tracking history for this
                          barcode.
                          <br />
                          Please make sure you have the right barcode and try
                          again.
                        </>
                      )}
                    </TrackingHistoryViewStateSpacer>
                  )}
                  {viewState === viewStates.nodata && (
                    <TrackingHistoryViewStateSpacer>
                      {isPendingReceiptFromShipper
                        ? "This package is pending receipt from shipper. Check back later to view tracking history."
                        : "No tracking history was found for this barcode in the last 14 days."}
                    </TrackingHistoryViewStateSpacer>
                  )}
                  {viewState === viewStates.success &&
                    (barcodeTrackingHistory.length > 0 ? (
                      barcodeTrackingHistory.map(
                        (trackingEvent, index, finalArray) => {
                          return (
                            <SimpleTransitionBoth
                              key={
                                index +
                                "-" +
                                trackingEvent.pkid +
                                "-" +
                                trackingEvent.barcode
                              } //pkid is not unique and switching between barcodes sometimes does not replay the animation. So adding in the barcode to the key as well.
                              delay={finalArray.length * 100 - index * 100}
                              duration=".5s"
                              transitionBaseStyle={{
                                opacity: 0,
                                transform: `translateY(${50}px)`,
                              }}
                              transitionEndStyle={{
                                opacity: 1,
                                transform: "translateY(0px)",
                              }}
                            >
                              <div
                                style={{
                                  position: "relative",
                                  display: "flex",
                                  borderBottom: "1px solid gray",
                                  backgroundColor:
                                    index === 0
                                      ? "rgba(0,0,0,.1)"
                                      : "transparent",
                                }}
                              >
                                <div
                                  style={{
                                    width: "60px",
                                    minWidth: "60px",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  {index === 0 ? (
                                    <EndingNotch />
                                  ) : index ===
                                    barcodeTrackingHistory.length - 1 ? (
                                    <StartingNotch />
                                  ) : (
                                    <MiddleNotch />
                                  )}
                                </div>
                                <div className="public-tracker-tracking-row">
                                  <div
                                    className={
                                      "p-4" + (index === 0 ? " font-600" : "")
                                    }
                                  >
                                    {trackingEvent.stopType === 1 ? (
                                      <>
                                        {trackingEvent.scannedWhen
                                          ? "Delivered "
                                          : "Completed "}
                                        - {trackingEvent.name}
                                      </>
                                    ) : (
                                      trackingEvent.name
                                    )}
                                    <br />
                                    {trackingEvent.city}, {trackingEvent.state}{" "}
                                    {trackingEvent.zip}
                                    <br />
                                    {trackingEvent.scannedWhen
                                      ? dateFormat(
                                          parseISO(trackingEvent.scannedWhen),
                                          "MM/dd/yyyy h:mm a",
                                        )
                                      : trackingEvent.completedTime
                                        ? dateFormat(
                                            parseISO(
                                              trackingEvent.completedTime,
                                            ),
                                            "MM/dd/yyyy h:mm a",
                                          )
                                        : "Expected"}
                                  </div>
                                  {trackingEvent.stopType === 1 && (
                                    <div className="public-tracker-images-container px-3 pl-md-0">
                                      {/* {trackingEvent.images?.map((image) => {
                                    return (
                                      <div className="public-tracker-img-container">
                                        <img
                                          alt="Picture of package"
                                          className="public-tracker-img"
                                          src={image}
                                        />
                                      </div>
                                    );
                                  })} */}
                                      {
                                        //if the most recent scan is a delivery scan, we can display the images for it
                                        index === 0 &&
                                          // trackingEvent.custID === 23583 && //current we only grab images for this client so don't need to add check here
                                          foundDeliveryImageInfo?.map(
                                            (imageInfo) => {
                                              return (
                                                <div
                                                  key={imageInfo.id}
                                                  className="public-tracker-img-container"
                                                  onClick={() => {
                                                    handleClickParcelImageModal(
                                                      imageInfo.id,
                                                    );
                                                  }}
                                                >
                                                  <BsImage size={30} />
                                                  <div
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    POD Image
                                                  </div>
                                                </div>
                                              );
                                            },
                                          )
                                      }
                                      {trackingEvent.custID !== 23583 &&
                                        trackingEvent.signature && (
                                          <div
                                            className="public-tracker-img-container"
                                            onClick={() => {
                                              handleClickPODSignatureImage(
                                                trackingEvent.signature,
                                                trackingEvent.pod,
                                              );
                                            }}
                                          >
                                            <FaFileSignature size={30} />
                                            {trackingEvent.pod && (
                                              <div
                                                style={{
                                                  // width: "6rem",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Signed by{" "}
                                                {trackingEvent.pod ?? "-"}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </SimpleTransitionBoth>
                          );
                        },
                      )
                    ) : (
                      <TrackingHistoryViewStateSpacer>
                        No tracking history was found for this barcode in the
                        last 14 days.
                      </TrackingHistoryViewStateSpacer>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
